<template>
  <BaseDialog
    v-model:is-visible="isVisible"
    :ui="{ title: 'text-error' }"
  >
    <template #title>
      <ExclamationTriangleIcon class="w-6 h-6" />
      Delete Account
    </template>

    <div class="space-y-4 mb-6">
      <p>
        Are you sure you want to delete your account? This action is <strong>permanent</strong> and cannot be undone.
      </p>
      
      <div class="p-4 bg-error/10 text-error rounded-lg text-sm space-y-2">
        <p class="font-bold">
          By deleting your account:
        </p>
        <ul class="list-disc ml-4 space-y-1">
          <li>All your songs and data will be permanently removed.</li>
          <li>Your profile and settings will be deleted.</li>
          <li>You will no longer be able to log in with this account.</li>
        </ul>
      </div>
    </div>

    <div class="flex justify-end gap-3">
      <BaseButton
        variant="text"
        @click="isVisible = false"
      >
        Cancel
      </BaseButton>
      <BaseButton
        color="error"
        :disabled="isLoading"
        @click="$emit('confirm')"
      >
        <template #icon>
          <TrashIcon class="w-4 h-4" />
        </template>
        Delete My Account
      </BaseButton>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from '@/components/BaseButton.vue';
import BaseDialog from '@/components/BaseDialog.vue';
import { ExclamationTriangleIcon, TrashIcon } from '@heroicons/vue/24/outline';

defineProps<{
  isLoading?: boolean
}>()
const isVisible = defineModel<boolean>('isVisible', { default: false });

defineEmits<{
  (e: 'confirm'): void
}>()
</script>
